{
  "alpha": "Alpha",
  "alphaFeedback": "Alpha-Feedback",
  "beta": "Beta",
  "betaFeedback": "Beta-Feedback"
}
